export const KEY_CODE_UP = 38;
export const KEY_CODE_DOWN = 40;
export const KEY_CODE_ESC = 27;
export const KEY_CODE_ENTER = 13;
export const KEY_CODE_TAB = 9;
export const KEY_CODE_DEL = 46;
export const KEY_CODE_SPACE = 32;
export const KEY_CODE_PAGE_UP = 33;
export const KEY_CODE_PAGE_DOWN = 34;


// WEBPACK FOOTER //
// ./web/js/keyCodes.js